export default "__VITE_ASSET__CV2IBZ$v__"